<template>
      <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'الحفظ والمراجعة'" :to="{name: 'saveReviews'}">متابعة الحفظ والمراجعة</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'saveReviews.edit', params: {id: data.form.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات متابعة الحفظ والمراجعة</h4>

                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                         <div class="row">
                                          
                                       <div class="col-md-4" v-show="user.role != 'teacher'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4" v-show="user.role != 'teacher'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى</label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4"  v-show="user.role != 'teacher'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحلقة</label>
                                            <treeselect :options="lessons" :auto-load-root-options="true" v-model="data.form.lesson_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المعلم</label>
                                            <treeselect :options="teachers" :auto-load-root-options="true" v-model="data.form.teacher_id" @select="getTeachers" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div :class="'col-md-' + (user.role == 'admin' ? '12' : '6')">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ</label>
                                            <date-picker v-model="data.form.date_and_time" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['date_and_time'] ? 'display: block' : 'display: none;'"  v-if="getErrors['date_and_time']">
                                                  {{ getErrors['date_and_time'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-12 table-responsive">
                                      <!-- <a href="#" @click.prevent="addStudent" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus">إضافة طالب </a> -->

                                        <table class="table table-bordered">
                                          <thead>
                                            <tr class="text-center">

                                              <th >#</th>
                                              <th colspan="3">الطالب</th>
                                              <th colspan="5">متابعة الحفظ</th>
                                              <th colspan="5">متابعة المراجعة</th>
                                              <th>درجة النهائية</th>
                                              <!-- <th>#</th> -->
                                             
                                            </tr>
                                            <tr>

                                              <th style="min-width: 60px;">#</th>
                                              <th style="min-width: 110px;">كود الطالب</th>
                                              <th style="min-width: 160px;">الطالب</th>

                                              <th style="min-width: 160px;">نوع الورد</th>

                                              <th style="min-width: 160px;">من</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th style="min-width: 160px;">إى سورة</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th style="min-width: 160px;">درجة الحفظ</th>

                                              <th style="min-width: 160px;">من</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th style="min-width: 160px;">إى سورة</th>
                                              <th style="min-width: 160px;">رقم الآية</th>
                                              <th>درجة المراجعة</th>

                                              <th style="min-width: 160px;">درجة الطالب</th>
                                              <!-- <th>#</th> -->
                                            </tr>
                                          </thead>

                                          <tbody>
                                            <tr v-for="(st, k) in data.form.students" :key="k">
                                              <td>
                                                <button v-if="st.id && !isChanged && data.form.is_draft == 0" type="button" class="btn btn-primary btn-sm" data-toggle="modal" @click="getStudentAddDregree(k)" data-target="#exampleModal">
                                                   <i class="fa fa-file"></i>
                                                </button>
                                              </td>

                                              <td v-if="data.form.students[k]">
                                                <h6>{{data.form.students[k].student_id}}</h6>
                                             
                                              </td>

                                              <td v-if="data.form.students[k]">
                                                <h6>{{data.form.students[k].student_name}}</h6>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_id']">
                                                      {{ getErrors['students.'+k+'.student_id'][0] }}
                                                </div>
                                              </td>
                                              <td v-if="data.form.students[k]">
                                                <select class="form-control" v-model="data.form.students[k].type" @change="handleType(k);reClcDegree(k)">
                                                  <option value="حفظ ومراجعة">حفظ و مراجعة</option>
                                                  <option value="حفظ">حفظ ففط</option>
                                                  <option value="مراجعة">مراجعة ففط</option>
                                                </select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.type'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.type']">
                                                      {{ getErrors['students.'+k+'.type'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'مراجعة'" :options="sura" v-model="data.form.students[k].save_from" @input="setAyaFromVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_from'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_from']">
                                                      {{ getErrors['students.'+k+'.save_from'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'مراجعة'" :options="data.form.students[k].save_from ? allSour[data.form.students[k].save_from] : []" v-model="data.form.students[k].save_from_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_from_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_from_aya']">
                                                      {{ getErrors['students.'+k+'.save_from_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'مراجعة'" :options="sura" v-model="data.form.students[k].save_to" @input="setAyaToVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_to'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_to']">
                                                      {{ getErrors['students.'+k+'.save_to'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'مراجعة'" :options="data.form.students[k].save_to ? allSour[data.form.students[k].save_to] : []" v-model="data.form.students[k].save_to_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_to_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_to_aya']">
                                                      {{ getErrors['students.'+k+'.save_to_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input :disabled="data.form.students[k].type == 'مراجعة'" type="text" v-model="data.form.students[k].save_degree" @change="clcDegree(k)" class="form-control">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.save_degree'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.save_degree']">
                                                      {{ getErrors['students.'+k+'.save_degree'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'حفظ'" :options="sura" v-model="data.form.students[k].review_from" @input="setReviewAyaVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_from'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_from']">
                                                      {{ getErrors['students.'+k+'.review_from'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'حفظ'"  :options="data.form.students[k].review_from ? allSour[data.form.students[k].review_from] : []" v-model="data.form.students[k].review_from_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_from_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_from_aya']">
                                                      {{ getErrors['students.'+k+'.review_from_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'حفظ'"  :options="sura" v-model="data.form.students[k].review_to" @input="setReviewAyaToVal($event, k)" ></v-select>
                                                 <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_to'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_to']">
                                                      {{ getErrors['students.'+k+'.review_to'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <v-select :disabled="data.form.students[k].type == 'حفظ'"  :options="data.form.students[k].review_to ? allSour[data.form.students[k].review_to] : []" v-model="data.form.students[k].review_to_aya"></v-select>
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_to_aya'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_to_aya']">
                                                      {{ getErrors['students.'+k+'.review_to_aya'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input :disabled="data.form.students[k].type == 'حفظ'"  type="text" v-model="data.form.students[k].review_degree" class="form-control" @change="clcDegree(k)">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.review_degree'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.review_degree']">
                                                      {{ getErrors['students.'+k+'.review_degree'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                 <input type="text" :disabled="true" v-model="data.form.students[k].student_degree" class="form-control">
                                                <div class="invalid-feedback" :style="getErrors['students.'+k+'.student_degree'] ? 'display: block' : 'display: none;'"   v-if="getErrors['students.'+k+'.student_degree']">
                                                      {{ getErrors['students.'+k+'.student_degree'][0] }}
                                                </div>
                                              </td>
                                              <!-- <td>
                                                <a href="#" class="btn btn-danger" v-if="k != 0" @click.prevent="deleteFromStudent(st)">X</a>
                                              </td> -->
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>

                                    <button type="button" v-if="data.form.is_draft == 1" @click.prevent="updateDraft" class="draft-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ مؤقت</span></button>
                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'saveReviews'}">
                                      <span>رجوع</span>
                                    </router-link>
                              </form>
                            </div>
                        </div>
                    </div>

                </div>

               <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                  <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                      <div class="modal-header">
                                        <h5 class="modal-title" id="exampleModalLabel">درجات التميز</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                      <div class="modal-body">
                                        <div class="row">
                                          <div class="col-md-12 " v-show="0">
                                            <div class="form-group mb-4">
                                                <label for="exampleFormControlInput12">التاريخ</label>
                                                <date-picker v-model="data.addDegree.date_and_time"  :calendar="'hijri'"></date-picker>
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="exampleFormControlInput12">الدرجات</label>
                                                <input type="text" v-model="data.addDegree.student_degree" @change="handleDegree" class="form-control">
                                            </div>
                                          </div>
                                          <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="exampleFormControlInput12">سبب منح درجة التميز</label>
                                                <input type="text" v-model="data.addDegree.reason" class="form-control">
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="modal-footer">
                                        <button type="button" class="btn btn-primary btn-rounded mb-4 mt-2" data-dismiss="modal" @click="addDegreeAction(k)">حفظ</button>
                                        <button type="button" class="btn btn-dark btn-rounded mb-4 mt-2" data-dismiss="modal">الغاء</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      isChangedData: 0,
      trans: {},
      data: {
        checkerExit: 0,
        addDegree: {
          teacher_id: '',
          lesson_id: '',
          date_and_time: '',
          student_id: '',
          reason: ''
        },
        form: {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          is_draft: 0,
          students: [{

          student_id: '',
          student_name: '',
          stOptions: [],
          ayaFromOptions: [],
          ayaToOptions: [],
          reviewAyaFromOptions: [],
          reviewAyaToOptions: [],
          type: 'حفظ ومراجعة',
          save_from: '',
          save_from_aya: '',
          save_to: '',
          save_to_aya: '',
          save_degree: '',

          review_from: '',
          review_from_aya: '',
          review_to: '',
          review_to_aya: '',
          review_degree: '',
          student_degree: ''
          }],
        },
        permissions: [],
        isRequested: false,
        errors: {},
        paginated: {},
        allSelected: false,
      },
      isChanged: 0,
      teachers: [],
      lessons: [],
      stages: [],
      groups: [],
      sura: [],
      allSour: []
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    resetForm(){
      this.data.form = {
          teacher_id: '',
          lesson_id: '',
          group_id: '',
          stage_id: '',
          date_and_time: '',
          is_draft: 0,

          students: [{

          student_id: '',
          student: '',
          stOptions: [],
          ayaFromOptions: [],
          ayaToOptions: [],
          reviewAyaFromOptions: [],
          reviewAyaToOptions: [],
          type: 'حفظ ومراجعة',
          save_from: '',
          save_from_aya: '',
          save_to: '',
          save_to_aya: '',
          save_degree: '',

          review_from: '',
          review_from_aya: '',
          review_to: '',
          review_to_aya: '',
          review_degree: '',
          student_degree: ''
          }],
        };
    },
    reClcDegree(k){
      this.data.form.students[k].student_degree = 0;
      this.data.form.students[k].review_degree = 0;
      this.data.form.students[k].save_degree = 0;
    },
    handleDegree(){
      this.data.addDegree.student_degree = this.data.addDegree.student_degree > 1.25 ? '1.25' : (this.data.addDegree.student_degree < 0 ? '0' : this.data.addDegree.student_degree);
    },
    addDegreeAction(k){
      let student = this.data.form.students[k];
      this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?addDegree_edit=1', {
                    params: {
                      student_id: this.data.addDegree.student_id,
                      lesson_id: this.data.addDegree.lesson_id,
                      date_and_time: this.data.addDegree.date_and_time,
                      teacher_id: this.data.addDegree.teacher_id,
                      reason: this.data.addDegree.reason,
                      student_degree: this.data.addDegree.student_degree,
                      id: this.data.addDegree.id
                    }
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.addDegree = {
                    teacher_id: '',
                    lesson_id: '',
                    date_and_time: '',
                    student_id: '',
                    reason: '',
                    student_degree: 0
                  };
            }
      }).catch((error) => {
        this.sweetAlert('عملية الاضافة لم تتم هناك شئ ما خطأ من فضلك حاول مرة اخرى', 'error');
        this.data.addDegree = {
                    teacher_id: '',
                    lesson_id: '',
                    date_and_time: '',
                    student_id: '',
                    reason: '',
                    student_degree: 0
                  };
      });
    },
    getStudentAddDregree(k){
      this.data.addDegree = {
                    teacher_id: '',
                    lesson_id: '',
                    date_and_time: '',
                    student_id: '',
                    reason: '',
                    student_degree: 0
                  };
      let student = this.data.form.students[k];
      this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?addDegree=1&student=' + student.student_id).then((response)=>{
            if(response.data.code == 200){
               this.data.addDegree = response.data.data.addDegree;
            }
      });
    },
    getInfo() {
      this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit').then((response) => {
        if (response.data.code == 200 && response.data.data != null) {
          this.data.form        = response.data.data.saveReview;
          this.teachers            = response.data.data.teachers;
          this.sura            = response.data.data.sura;
          this.stages            = response.data.data.stages;
          this.groups            = response.data.data.groups;
          this.lessons            = response.data.data.lessons;
          this.allSour            = response.data.data.allSour;
          if(this.user.role == 'teacher'){
            this.data.form.teacher_id = this.user.teacher_id;
          }
          setTimeout(() => {
          this.isChangedData = 1;
            
          }, 3000);
        } else if (response.data.code == 404) {
          router.push('/saveReviews');
        } else {
          alert(response.data.data.error);
          router.push('/saveReviews');
        }
      });
    },
      validateStudentsBeforeStore() {
      for (let i = 0; i < this.data.form.students.length; i++) {
        const st = this.data.form.students[i];

        // type لازم يكون موجود
        if (!st.type) {
          this.sweetAlert(`برجاء اختيار نوع الحفظ / المراجعة للطالب رقم ${st.student_id}`, 'error');
          return false;
        }

        // حسب النوع نتحقق من البيانات المطلوبة
        if (st.type === 'حفظ' || st.type === 'حفظ ومراجعة') {
          if (
            !st.save_from ||
            !st.save_from_aya ||
            !st.save_to ||
            !st.save_to_aya ||
            st.save_degree == null
          ) {
            this.sweetAlert(`بيانات الحفظ غير مكتملة للطالب رقم ${st.student_id}`, 'error');
            return false;
          }
        }

        if (st.type === 'مراجعة' || st.type === 'حفظ ومراجعة') {
          if (
            !st.review_from ||
            !st.review_from_aya ||
            !st.review_to ||
            !st.review_to_aya ||
            st.review_degree == null
          ) {
            this.sweetAlert(`بيانات المراجعة غير مكتملة للطالب رقم ${st.student_id}`, 'error');
            return false;
          }
        }

        // الدرجة النهائية
        if (st.student_degree == null) {
          this.sweetAlert(`الدرجة النهائية غير محسوبة للطالب رقم ${st.student_id}`, 'error');
          return false;
        }
      }

      return true;
    },
    update() {
      if (!this.validateStudentsBeforeStore()) {
        return;
      }
      this.data.isRequested = true;
      this.data.form.is_draft = 0;

      this.$baseApi.patch('/saveReviews/' + this.data.form.id, this.data.form).then((response) => {
        if (response.data.code === 200) {
          this.resetForm();
          localStorage.setItem('flash_message', 'تمت عملية العديل');
          this.sweetAlert('تم التعديل بنجاح');
          router.push('/saveReviews');

        }
      }).catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {

            const errors = error.response.data.errors;

            // جيب أول رسالة خطأ
            const firstError = Object.values(errors)[0][0];

            this.sweetAlert(firstError, 'error');

            this.data.errors = errors;
          }

          this.data.isRequested = false;
      })
    },
    updateDraft() {
      this.data.isRequested = true;
      this.data.form.is_draft = 1;
      this.$baseApi.patch('/saveReviews/' + this.data.form.id, this.data.form).then((response) => {
        if (response.data.code === 200) {
          // this.resetForm();
          localStorage.setItem('flash_message', 'تمت عملية العديل');
          this.sweetAlert('تم التعديل بنجاح');
          // router.push('/saveReviews');
          window.location.reload();

        }
      }).catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {

            const errors = error.response.data.errors;

            // جيب أول رسالة خطأ
            const firstError = Object.values(errors)[0][0];

            this.sweetAlert(firstError, 'error');

            this.data.errors = errors;
          }

          this.data.isRequested = false;
      })
    },

     deleteFromStudent(data){
      this.data.form.students.splice(this.data.form.students.indexOf(data), 1);
    },
    addStudent(){
      this.data.form.students.push({
          student_id: '',
          student_name: '',
          stOptions: [],
          ayaFromOptions: [],
          ayaToOptions: [],
          reviewAyaFromOptions: [],
          reviewAyaToOptions: [],
          type: 'حفظ ومراجعة',
          save_from: '',
          save_from_aya: '',
          save_to: '',
          save_to_aya: '',
          save_degree: '',

          review_from: '',
          review_from_aya: '',
          review_to: '',
          review_to_aya: '',
          review_degree: '',
          student_degree: ''
      })
    },
    handleType(k){
      let type = this.data.form.students[k].type;
      if(type == 'حفظ'){
        this.data.form.students[k].review_degree = 0;
        this.data.form.students[k].review_to_aya = '';
        this.data.form.students[k].review_to = '';
        this.data.form.students[k].review_from_aya = '';
        this.data.form.students[k].review_from = '';
        this.data.form.students[k].student_degree = this.data.form.students[k].save_degree;
      }else if(type == 'مراجعة'){
        this.data.form.students[k].save_degree = 0;
        this.data.form.students[k].save_to_aya = '';
        this.data.form.students[k].save_to = '';
        this.data.form.students[k].save_from_aya = '';
        this.data.form.students[k].save_from = '';
        this.data.form.students[k].student_degree = this.data.form.students[k].review_degree;
      }else{

      }
      this.clcDegree(k);
    },
    clcDegree(k){
      if(this.data.form.students[k].review_degree > 20){
        this.data.form.students[k].review_degree = 20;
        this.sweetAlert('لا يمكنك اختيار رقم اكبر من 20', 'warning');
      }
      if(this.data.form.students[k].save_degree > 20){
        this.data.form.students[k].save_degree = 20;
        this.sweetAlert('لا يمكنك اختيار رقم اكبر من 20', 'warning');
      }
      let type = this.data.form.students[k].type;
      if(type == 'حفظ ومراجعة'){
        if(this.data.form.students[k].review_degree && this.data.form.students[k].save_degree){
          let clc = ((Number(this.data.form.students[k].review_degree) + Number(this.data.form.students[k].save_degree)) / 2);
          this.data.form.students[k].student_degree = clc;
        }
      }else if(type == 'حفظ'){
        if(this.data.form.students[k].save_degree > 20){
          this.data.form.students[k].save_degree = 20;
        }
        this.data.form.students[k].student_degree = this.data.form.students[k].save_degree;
      }else{
        this.data.form.students[k].student_degree = this.data.form.students[k].review_degree;

      }
    },

     getGroups(val){
         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.groups = response.data.data.groups;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getLessons(val){
         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?option=lesson&i='+val.id).then((response)=>{
            if(response.data.code == 200){
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      getStudents(){
         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?option=student&i='+this.data.form.lesson_id + '&d='+ this.data.form.date_and_time).then((response)=>{
            if(response.data.code == 200){
               this.data.form.students = response.data.data.students;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        }).catch((error) => {
          this.data.form.students = [];
          this.sweetAlert(error.response.data.errors[0], 'error');
        });;
      },


     getTeachers(val){
      this.data.form.teacher_id = '';
      this.data.form.students   = [];
      this.isChanged = 1;
      if(this.user.role == 'teacher'){
        this.data.form.teacher_id = this.user.teacher_id;
        return;
      }
      this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?l=' + val.id).then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
    },
      setReviewAyaVal($event, key){
               this.data.form.students[key].review_to  = $event;

         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].reviewAyaFromOptions  = response.data.data.options;
               this.data.form.students[key].reviewAyaToOptions  = response.data.data.options;


            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

       setReviewAyaToVal($event, key){
         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].reviewAyaToOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      setAyaFromVal($event, key){
        this.data.form.students[key].save_to = $event;

         this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].ayaFromOptions  = response.data.data.options;
               this.data.form.students[key].ayaToOptions    = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      setAyaToVal($event, key){
        this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?sura=' + $event).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].ayaToOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },

      setNewStVal($event, k){
          for (let index = 0; index < this.data.form.students.length; index++) {
              if($event.id == this.data.form.students[index].student_id){
                this.sweetAlert('لا يمكنك اختيار طالب اكثر من مرة', 'warning');
                this.data.form.students[k].student_id = null;
                this.data.form.students[k].student    = null;
                return;
              }
          }
           this.data.form.students[k].student_id = $event && $event.id ? $event.id : '';
           this.data.form.students[k].student = $event && $event.id ? $event.label : '';
        },

  loadOptions(search, key) {
    if(this.data.form.lesson_id == ''){
      this.sweetAlert('لا يمكنك اختيار طالب قبل اختيار الحلقة', 'warning');
      return;
    }
    if(search == ''){
      this.data.form.students[key].stOptions = [];
      return;
    }
      this.$baseApi.get('/saveReviews/' + this.$route.params.id + '/edit?student=' + search + '&lesson=' + this.data.form.lesson_id).then((response)=>{
            if(response.data.code == 200){

               this.data.form.students[key].stOptions  = response.data.data.options;

            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
  }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
  watch:{
     'data.form.date_and_time': function (newVal, oldVal){
        if(this.isChangedData){
          this.getStudents();
        }
     }
 }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}
.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
